import React from 'react';
import Button from '../button/index'
import { navigate } from 'gatsby'
import { CTAContainer } from './style';

export function CTAFold() {
  return(
    <CTAContainer>
        <div className="cta-text">
          <h1>Seguro Residencial CredPago</h1>
          <p>Coberturas essenciais, sem pesar no seu bolso.</p>
          <Button onClick={() => navigate('/#como-contratar')}>Veja como é fácil contratar</Button>
        </div>
    </CTAContainer>
  )
}